import { requiredFieldValidator } from './requiredFieldVaildator';

interface InputValidator {
  (name: string, prefixStr: string): string;
}
export const nameValidator: InputValidator = (name, prefixStr) => {
  let errMsgStr = '';
  if (!requiredFieldValidator(name.trim())) errMsgStr = `* ${prefixStr} is required`;
  else if (!/^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/.test(name.trim())) {
    errMsgStr = 'Please provide valid First Name';
  }

  return errMsgStr;
};
